//该文件用于创建Vuex中最为核心的store
import Vue from 'vue'
//引入Vuex
import Vuex from 'vuex'
//应用Vuex插件
Vue.use(Vuex)

//准备和计算有关的数据
import me from './Me'
import problem from './problem'
import chat from './chat'
import course from './course'

//创建 并 导出 store
export default new Vuex.Store({
    modules: {
        me,
        personsabout:chat,
        problem,
        course,
    }
})

